import { useState, useEffect, useCallback, useMemo } from "preact/hooks";

interface UseTypeOfCareSyncProps {
  type_of_care?: string;
  urlTypeOfCare: string | null;
  syncedTypeOfCare?: string;
  syncedHandleTypeOfCareChange: (typeOfCare: string) => void;
}

export const useTypeOfCareSync = ({
  type_of_care,
  urlTypeOfCare,
  syncedTypeOfCare,
  syncedHandleTypeOfCareChange,
}: UseTypeOfCareSyncProps) => {
  const initialTypeOfCare = useMemo(() => {
    if (urlTypeOfCare) {
      return urlTypeOfCare;
    }
    return type_of_care || syncedTypeOfCare;
  }, [urlTypeOfCare, type_of_care, syncedTypeOfCare]);

  const [typeOfCare, setTypeOfCare] = useState<string | undefined>(initialTypeOfCare);

  const shouldSyncFromSynced = useMemo(() => {
    return !urlTypeOfCare && syncedTypeOfCare !== undefined;
  }, [urlTypeOfCare, syncedTypeOfCare]);

  const shouldSyncToGlobal = useMemo(() => {
    return urlTypeOfCare && urlTypeOfCare !== syncedTypeOfCare;
  }, [urlTypeOfCare, syncedTypeOfCare]);

  useEffect(() => {
    if (shouldSyncFromSynced) {
      setTypeOfCare(syncedTypeOfCare);
    }
  }, [shouldSyncFromSynced, syncedTypeOfCare]);

  useEffect(() => {
    if (shouldSyncToGlobal && urlTypeOfCare) {
      syncedHandleTypeOfCareChange(urlTypeOfCare);
    }
  }, [shouldSyncToGlobal, syncedHandleTypeOfCareChange, urlTypeOfCare]);

  const handleTypeOfCareChange = useCallback((newTypeOfCare: string) => {
    setTypeOfCare(newTypeOfCare);
    syncedHandleTypeOfCareChange(newTypeOfCare);
  }, [syncedHandleTypeOfCareChange]);

  return {
    typeOfCare,
    handleTypeOfCareChange,
  };
};
